import { useCallback } from 'react';
import { doPOSTJSON, getApiUrl } from '../api';
import { Photo } from '../models_generated';
import { ROUTES } from '../routes';

export function BaseView(props: {children: any}) {
  const onCreateNew = useCallback(async (e: any) => {
    e.preventDefault();
    if (window.confirm("Da li ste sigurni da želite dodati novu fotografiju?")) {
      try {
        const resp = await fetch(getApiUrl("/photo"), {method: "post", mode: "cors"})
        const jsn = await resp.json();
        window.location.href = ROUTES.PHOTO.url(jsn.id);
      } catch (e) {
        alert(e);
      }
    }
  }, [])

  const onLogout = useCallback(async (e: any) => {
    e.preventDefault();
    try {
		await doPOSTJSON(`/logout`, {});
    } catch (e) {
      alert(e);
    }
  }, [])

	return <div className="App">
      <a href={ROUTES.PHOTOS.url()}>Spisak fotografija photos</a>
      &nbsp; &middot; &nbsp;
      <a href="#" onClick={onCreateNew}>Dodaj novu fotografiju</a>
      &nbsp; &middot; &nbsp;
      Pregledi
      &nbsp; &middot; &nbsp;
      <a href={ROUTES.PRINT_BOOK.url()} target='_blank'>Print</a>
      &nbsp; &middot; &nbsp;
      <a href="#" onClick={onLogout}>Logout</a>
      <hr/>
		{props.children}
    </div>
}